import React, {PureComponent} from "react"
import {connect} from "react-redux"
import styled from "styled-components"
import {
    commonLocalization,
    projectsLocalization,
    currency,
    number,
} from "../../../localization"
import LayeredBarChart from "../../charts/bar-chart/layered-bar-chart"
import {
    Heading,
    Text,
} from "../../styled"
import {withRouter} from "react-router-dom"
import {get} from "lodash"
import { images } from "../../../config/index";
import NoData from "../noData"

class ProjectProcurementChart extends PureComponent {
    handleClick = data => {
        const procurementType = data.procurement_type.split(" ").join("_")
        this.props.history.push({
            pathname: "/projects",
            search: `?procurement_type=${procurementType}&fiscal-year=${this.props.fiscalYear}`,
        })
    }

    prepareData = data => {
        if (data.length < 1) {
            return []
        }
        let preparedData = []
        const {selectedDropDown, selectedLanguage} = this.props

        Object.entries(data).forEach(([type, stat]) => {
            let procurement_type_in_nepali = projectsLocalization[selectedLanguage].procurementTypes[type]

            if (type === "undefined" || stat === undefined) {
                return
            }

            if (this.props.selectedWard === "all") {
                stat = get(stat, "overall")
            } else {
                stat = get(stat, `ward_wise.${this.props.selectedWard}`)
            }

            if (selectedDropDown === "budget") {
                preparedData.push({
                    "procurement_type": type.replace(/_|-/g, " "),
                    "procurement_type_in_nepali": procurement_type_in_nepali,
                    "budget": get(stat, "total.budget.value", 0),
                    "expenditure": get(stat, "total.expenditure.value", 0),
                })
            }

            if (selectedDropDown === "count") {
                preparedData.push({
                    "procurement_type": type.replace(/_|-/g, " "),
                    "procurement_type_in_nepali": procurement_type_in_nepali,
                    "projects": get(stat, "total.count", 0),
                })
            }
        })

        return preparedData
    }

    render() {
        const {selectedLanguage, procurement_type, selectedDropDown} = this.props
        const chartData = this.prepareData(procurement_type || [])

        return (
          <ChartsBlock className="charts-block" lang={selectedLanguage}>
            <Heading.h2
              uppercase
              style={{ marginBottom: 8 }}
              className="flex items-center"
            >
              <Text.span className="help-text">
                <Text.span className="help-text__icon">
                  <img
                    className="help-icon"
                    height={18}
                    width={18}
                    src={images.icons.help}
                    alt="help"
                  />
                </Text.span>
                <Text.span className="help-text__content tooltip">
                  <Text.span className="tooltip-arrow">arrow</Text.span>
                  {selectedLanguage === "en"
                    ? "The bar chart shows the total number of projects distributed across the different procurement types."
                    : "यस Bar Chart ले विभिन्न खरीद प्रकार मार्फत वितरण परियोजनाहरूको कुल संख्या देखाउँछ।"}
                </Text.span>
              </Text.span>
              <span>
                {" "}
                {selectedLanguage === "en"
                  ? "BarChart view of Project Distribution across procurement types"
                  : "खरीद प्रकार मार्फत परियोजना वितरण को BarChart दृश्य"}
              </span>
            </Heading.h2>

            <div className="card--chart procurement-chart">
              {selectedDropDown === "budget" &&
                (chartData.length ? (
                  <LayeredBarChart
                    xKey="procurement_type"
                    yKey="budget"
                    y1Key="expenditure"
                    chartData={chartData}
                    onClick={(datum) => this.handleClick(datum)}
                    tooltip={({ procurement_type, budget, expenditure }) => {
                      const {
                        budget: budgetText,
                        expenditure: expenditureText,
                        nrs,
                      } = commonLocalization[selectedLanguage];

                      if (selectedLanguage === "np") {
                        procurement_type = procurement_type
                          ? procurement_type.split(" ").join("_")
                          : "";
                        procurement_type =
                          projectsLocalization[selectedLanguage]
                            .procurementTypes[procurement_type];
                      }

                      return (
                        <div>
                          <div>
                            {procurement_type ? (
                              <span className="total-count">
                                {procurement_type.replace(
                                  procurement_type[0],
                                  procurement_type[0].toUpperCase()
                                )}
                              </span>
                            ) : (
                              ""
                            )}
                          </div>
                          <div className={"py-1"}>
                            <div>
                              {budget ? (
                                <span className="title">
                                  <b className={"font-semibold"}>
                                    {budgetText}
                                  </b>
                                  : {nrs} {currency(budget)}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                            <div>
                              {expenditure ? (
                                <span className="title">
                                  <b className={"font-semibold"}>
                                    {expenditureText}
                                  </b>
                                  : {nrs} {currency(expenditure)}
                                </span>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                          <div className="view-map-detail fixed-width-tooltip">
                            {selectedLanguage === "np"
                              ? "परियोजनाहरु  हेर्नकालागि क्लिक  गर्नुहोस्"
                              : "Click to view by project category."}
                          </div>
                        </div>
                      );
                    }}
                  />
                ) : (
                  <div className="data-not-available">
                    <img
                      src={images.dataNotAvailable}
                      alt="data not available"
                    />
                    <Text.span>
                      {commonLocalization[selectedLanguage]["dataNotAvailable"]}
                    </Text.span>
                  </div>
                ))}
              {selectedDropDown === "count" &&
                (chartData.length ? (
                  <LayeredBarChart
                    xKey="procurement_type"
                    yKey="projects"
                    y1Key="projects"
                    chartData={chartData}
                    onClick={(datum) => this.handleClick(datum)}
                    tooltip={({ procurement_type, projects }) => {
                      if (selectedLanguage === "np") {
                        procurement_type = procurement_type
                          ? procurement_type.split(" ").join("_")
                          : "";
                        procurement_type =
                          projectsLocalization[selectedLanguage]
                            .procurementTypes[procurement_type];
                      }

                      return (
                        <div>
                          {procurement_type ? (
                            <span className="total-count">
                              {procurement_type.replace(
                                procurement_type[0],
                                procurement_type[0].toUpperCase()
                              )}
                            </span>
                          ) : (
                            ""
                          )}
                          {projects ? (
                            <span className="title">{number(projects)}</span>
                          ) : (
                            ""
                          )}

                          <div className="view-map-detail fixed-width-tooltip">
                            {selectedLanguage === "np"
                              ? "परियोजनाहरु  हेर्नकालागि क्लिक  गर्नुहोस्"
                              : "Click to view by project category."}
                          </div>
                        </div>
                      );
                    }}
                  />
                ) : <NoData selectedLanguage={selectedLanguage} />)}
            </div>
          </ChartsBlock>
        );
    }
}

const ChartsBlock = styled.div`
            h2 {
            font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
            > span:last-child {
            font-size: ${props => (props.lang === "en" ? "12px" : "14px")};
            opacity: 0.7;
            }
            }
            .help-text__content {
            font-size: ${props => (props.lang === "en" ? "11px" : "13px")};
            }
            `

export default withRouter(
    connect(state => ({
        selectedLanguage: state.localizationReducers.selectedLanguage,
        selectedWard: state.projectsStatsReducers.selectedWard,
        overall: state.projectsStatsReducers.data.data.overall,
        procurement_type: state.projectsStatsReducers.data.data.procurement_type,
        fiscalYear: state.fiscalYearReducers.selectedFiscalYear,
    }))(ProjectProcurementChart),
)



// WEBPACK FOOTER //
// ./src/components/layouts/projectProcurementChart/projectProcurementChart.js